<template>
  <div class="upload-bd">
    <!-- 单个图片 -->
    <el-upload
      v-if="type === 'text'"
      action="#"
      :disabled="disabled"
      :auto-upload="false"
      :on-change="onChangeUpload"
      :on-preview="onPreview"
      :on-remove="onRemove"
      accept="image/gif, image/jpeg"
      :show-file-list="false"
      class="single-img"
      :file-list="value"
    >
      <div
        v-if="value && value[0]"
        class="img-container"
      >
        <img
          :src="getAttachUrl(value[0])"
          class="avatar"
        />
        <div
          v-if="!disabled"
          class="del-content"
          @click.stop="onRemove(value[0])"
        >
          <div class="del-mask"></div>
          <i class="icon icon-shanchu"></i>
        </div>
      </div>
      <i
        v-else
        slot="default"
        class="el-icon-plus avatar-uploader-icon"
      ></i>
      <div
        v-if="tip"
        slot="tip"
        class="el-upload__tip"
      >{{ tip }}</div>
    </el-upload>
    <!-- 图片列表 -->
    <el-upload
      v-if="type === 'image'"
      list-type="picture-card"
      action="#"
      :disabled="disabled"
      :auto-upload="false"
      :on-change="onChangeUpload"
      :on-preview="onPreview"
      :on-remove="onRemove"
      :on-exceed="onExceed"
      accept="image/*"
      :limit="limit"
      :file-list="value"
    >
      <i
        slot="default"
        class="el-icon-plus center"
      ></i>
      <div
        v-if="tip"
        slot="tip"
        class="el-upload__tip"
      >{{ tip }}</div>
    </el-upload>
    <!-- 文件列表 -->
    <el-upload
      v-if="type === 'file'"
      action="#"
      :disabled="disabled"
      :auto-upload="false"
      :on-change="onChangeUpload"
      :on-preview="onPreview"
      :on-remove="onRemove"
      :on-exceed="onExceed"
      :limit="limit"
      :file-list="value"
      :class="{ disabled: disabled }"
      :accept="accept"
    >
      <el-button
        v-if="!disabled"
        size="small"
        type="primary"
      ><i
          class="icon"
          :class="buttonIcon"
          v-if="buttonIcon"
        ></i><span class="upload-text">{{ $t('upload.shang_chuan') }}</span></el-button>
      <div
        v-if="tip"
        slot="tip"
        class="el-upload__tip"
      >{{ tip }}</div>
    </el-upload>

    <!-- 可拖拽文件列表 -->
    <el-upload
      v-if="type === 'dragFile'"
      action="#"
      :disabled="disabled"
      :auto-upload="false"
      :on-change="onChangeUpload"
      :on-preview="onPreview"
      :on-remove="onRemove"
      :on-exceed="onExceed"
      :limit="limit"
      :file-list="value"
      :class="{ disabled: disabled }"
      :accept="accept"
      drag
      class="drag-file"
    >
      <i class="icon icon-file-drag"></i>
      <div class="drag-tips">{{ $t('upload.djhtdwjdzl') }}</div>
      <div class="file-size-limit">{{ $t('upload.wjdxbncg1M') }}</div>
      <div
        v-if="tip"
        slot="tip"
        class="el-upload__tip"
      >{{ tip }}</div>
    </el-upload>

    <!-- 视频 -->

    <!-- 培训视频图片 -->
    <el-upload
      v-if="type === 'videoCover'"
      class="videoCover-uploader"
      action="#"
      :disabled="disabled"
      :on-change="onChangeUpload"
      :on-preview="onPreview"
      :on-remove="onRemove"
      :on-exceed="onExceed"
      :limit="limit"
      :file-list="value"
      :auto-upload="false"
      accept="image/*"
    >
      <div
        class="cover"
        v-if="value.length > 0"
      >
        <img
          :src="value[0].url"
          class="avatar cover-avatar"
        />
      </div>
      <div
        v-else
        class="videoCover-uploader-icon"
      >
        <i class="el-icon-plus"></i>
        <div class="el-upload__text">{{ title }}</div>
      </div>
    </el-upload>

    <!-- 培训视频  带上传进度 on-progress on-success -->
    <!--     -->
    <!-- ossConfig.host -->
    <el-upload
      v-if="type === 'videoProgress' && ossConfig.host"
      ref="videoProgress"
      class="avatar-uploader el-upload--text"
      :action="ossConfig.host"
      :data="ossConfig"
      :disabled="disabled"
      :on-success="uploadVideoSuccess"
      :on-change="onChangeUpload"
      :on-progress="uploadVideoProcess"
      :before-upload="beforeUploadVideo"
      :on-remove="onRemove"
      :on-exceed="onExceed"
      :http-request="submit"
      :limit="limit"
      :file-list="value"
      :auto-upload="autoUpload"
      accept="video/*"
    >
      <el-progress
        v-if="videoFlag == true"
        type="circle"
        :percentage="videoUploadPercent"
        style="margin:70px 0;"
      ></el-progress>
      <div
        class="video"
        v-if="value.length > 0"
      >
        <video
          :src="value[0].url"
          class="avatar video-avatar"
          controls="controls"
          ref="video"
          @click.stop=""
        >
          {{ $t('upload.ndllqbzcspbf') }}
        </video>
        <span
          class="el-upload-list__item-delete"
          @click="onRemove(file)"
        >
          <i class="el-icon-delete"></i>
        </span>
      </div>
      <!-- <i v-else class="el-icon-plus avatar-uploader-icon"></i> -->
      <div
        v-else
        class="avatar-uploader-icon"
      >
        <i class="el-icon-plus"></i>
        <div class="el-upload__text">{{ title }}</div>
      </div>
    </el-upload>

    <!-- 图片预览 -->
    <el-dialog
      v-drag-dialog
      :title="$t('upload.tu_pian_yu_lan')"
      :append-to-body="true"
      :visible.sync="dialogVisible"
    >
      <img
        width="100%"
        :src="dialogImageUrl"
        alt
      />
    </el-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
// 1. 业务id（bizId) 业务id
// 2. 业务类型（bizType) 业务类型
// 3. 资源类型（attachType）: 1-图片，2-文件，3-视频

export default {
  props: {
    // text
    // image
    // file
    // videoCover
    // videoProgress
    // dragFile
    type: {
      type: String,
      default: 'image',
    },
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    bizId: {
      type: [String, Number],
      default: '',
    },
    bizType: {
      type: String,
      default: '',
    },
    limit: {
      type: Number,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    tip: {
      type: String,
      default: '',
    },
    accept: {
      type: String,
      default: '*',
    },
    title: {
      type: String,
      default: '',
    },
    buttonIcon: {
      type: String,
      default: '',
    },
    buttonText: {
      type: String,
      default: '',
    },
    url: {
      type: String,
      default: '',
    },
    autoUpload: {
      type: Boolean,
      default: true
    },
    // 文件夹地址
    folder: {
      type: String,
      default: '',
    },
    // 当bizId和bizType获取到的fileList为空时，保留外部传入的value
    isKeepValue: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    selfButtonText() {
      return this.buttonText || this.$t('upload.wen_jian_shang_chuan');
    },
  },
  data() {
    return {
      // 上传配置
      ossConfig: {},
      dialogImageUrl: '',
      dialogVisible: false,
      // 视频上传
      videoFlag: false,
      videoUploadPercent: '',
    };
  },
  watch: {
    bizId: function () {
      this.getOssAttach();
    },
    bizType: function () {
      this.getOssAttach();
    },
  },
  mounted: function () {
    this.getOssConfig();
    this.getOssAttach();
  },
  methods: {
    // 获取oss配置
    getOssConfig: function () {
      const folder = this.$getUploadFolder(this.bizType);
      this.$getJSON(apis.ossUpload, { folder }).then((res) => {
        this.ossConfig = res.data;
      });
    },
    // 图片预览/文件下载
    onPreview(file) {
      if (this.type === 'image') {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
        return;
      }
      this.jumpOutside(file.url);
    },
    // 图片删除/文件删除
    onRemove(file) {
      const list = this.value.filter(t => t.uid !== file.uid);
      this.$emit('input', list);
      this.$emit('effect');
    },
    // 文件超出
    onExceed: function () {
      this.$message.error(this.$t('upload.zdscogwj', [this.limit]));
    },
    // 资源加载显示
    getOssAttach: function () {
      if (!this.bizId || !this.bizType) {
        return;
      }
      this.$getJSON(`${apis.OssAttach}/${this.bizId}/${this.bizType}`).then((res) => {
        const list = res.data;
        list.forEach((item) => {
          item.url = this.getAttachUrl(item);
          item.name = item.attachName;
          item.bizType = this.bizType;
        });
        if (!list.length) {
          if (this.isKeepValue) {
            this.$emit('input', this.value);
          } else {
            this.$emit('input', []);
          }
        } else {
          this.$emit('input', list);
        }


        if (this.type === 'videoProgress') {
          setTimeout(() => {
            const duration = this.$refs.video.duration || 0;
            this.$emit('effect', {
              duration,
            });
          }, 1000);
        } else {
          this.$emit('effect');
        }
      });
    },
    submit() {
      let fileList = this.value;
      if (!fileList || !fileList.length) {
        return Promise.resolve([]);
      }
      fileList = fileList.map((item, index) => ({
        ...item,
        index
      }));
      const waitUploadList = fileList.filter(item => item.raw);
      if (!waitUploadList.length) {
        return Promise.resolve(fileList);
      }

      const reqList = waitUploadList.map(file => this.$postOss(file.raw, this.ossConfig, (progressEvent) => {
        this.videoFlag = true;
        this.videoUploadPercent = Number(
          ((progressEvent.loaded / progressEvent.total) * 100).toFixed(0)
        );
      }).then((res) => {
        const fileData = res.data;
        fileData.uid = file.uid;
        const name = fileData.name;
        fileData.attachName = name;
        fileData.url = this.getAttachUrl(fileData);
        fileData.bizType = this.bizType;
        fileData.bizId = fileData.bizId || this.bizId;
        return fileData;
      }));
      return Promise.all(reqList).then((resList) => {
        const arr = [...fileList];
        resList.forEach((item, index) => {
          arr[
            waitUploadList[index].index
          ] = item;
        });
        this.$emit('input', arr);
        if (waitUploadList.length === 1) {
          this.$emit('effect', waitUploadList[0]);
          this.$emit('fileRaw', waitUploadList[0].raw);
        }
        return arr;
      });

      // }
    },
    // 图片上传
    onChangeUpload: function (file, fileList) {
      if (file.size / 1024 / 1024 > 500) {
        this.$message.error(this.$t('upload.wjbncg500M'));
        fileList.pop();
        this.$emit('input', fileList);
        return;
      }
      if (this.autoUpload) {
        // 如果有url传入就上传到指定的接口  默认为空
        if (this.url) {
          const url = apis[this.url];
          this.$postFile(url, file.raw, {
            multipartFile: file.raw,
          }).then((res) => {
            const fileData = res.data.aliYunOssCallbackDto;
            fileData.uid = file.uid;
            fileData.url = this.getAttachUrl(fileData);
            fileData.bizType = this.bizType;
            const list = JSON.parse(JSON.stringify(this.value));
            list.push(fileData);
            this.$emit('input', list);
            // 数据结果不一样  通过emit自行赋值
            this.$emit('effect', res.data);
          });
        } else {
          this.$postOss(file.raw, this.ossConfig).then((res) => {
            const fileData = res.data;
            fileData.uid = file.uid;
            fileData.url = this.getAttachUrl(fileData);
            fileData.bizType = this.bizType;
            const list = JSON.parse(JSON.stringify(this.value));
            if (this.type === 'text') {
              this.$emit('input', [fileData]);
            } else {
              list.push(fileData);
              this.$emit('input', list);
              this.$emit('effect');
              this.$emit('fileRaw', file.raw);
            }
          });
        }
      } else {
        file.uid = this.getUUID();
        this.getFilePreviewUrl(file.raw).then((url) => {
          file.attachPath = url;
          file.src = url;
          file.url = url;
          this.$emit('input', fileList);
          this.$emit('fileRaw', file.raw);
          if (this.type === 'videoProgress') {
            setTimeout(() => {
              const duration = this.$refs.video.duration || 0;
              this.$emit('effect', {
                duration,
              });
            }, 1000);
          } else {
            this.$emit('effect');
          }
        });
      }
    },
    // 上传进度 要自动上传才生效
    uploadVideoProcess(event, file) {
      this.videoFlag = true;
      this.videoUploadPercent = parseInt(file.percentage, 10);
    },
    // 上传
    // eslint-disable-next-line consistent-return
    beforeUploadVideo: function (file) {
      const isLt500M = file.size / 1024 / 1024 < 500;
      if (['video/mp4', 'video/ogg', 'video/flv', 'video/avi', 'video/wmv', 'video/rmvb'].indexOf(file.type) === -1) {
        this.$message.error(this.$t('upload.spgsbzq'));
        return false;
      }
      if (!isLt500M) {
        this.$message.error(this.$t('upload.wjbncg500M'));
        return false;
      }
    },
    // 自动上传成功
    uploadVideoSuccess: function (response, file) {
      // 获取上传图片地址
      this.videoFlag = false;
      this.videoUploadPercent = 0;
      const fileData = response.data;
      fileData.uid = file.uid;
      fileData.attachName = fileData.attachName;
      fileData.url = this.getAttachUrl(fileData);
      fileData.bizType = this.bizType;
      // const list = JSON.parse(JSON.stringify(this.value));
      const list = [];
      list.push(fileData);
      this.$emit('input', list);
      this.$emit('successProgress');
      // fileList = list;
      if (list.length) {
        setTimeout(() => {
          // console.log(this.$refs.video.duration);
          const duration = this.$refs.video.duration || 0;
          this.$emit('effect', {
            duration,
          });
        }, 1000);
      }
    },
  },

};
</script>

<style lang="scss">
.upload-bd {
  .disabled .el-upload {
    display: none;
  }

  .single-img {
    position: relative;
    width: 200px;
    height: 200px;
    background: #fff;
    overflow: hidden;

    .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .el-upload:hover {
      border-color: #409eff;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 178px;
      height: 178px;
      line-height: 178px;
      text-align: center;
    }
    .img-container {
      position: relative;
      width: 178px;
      height: 178px;

      .avatar {
        width: 178px;
        height: 178px;
        display: block;
        z-index: 0;
        position: relative;
      }

      .del-content {
        position: absolute;
        z-index: 10;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        line-height: 178px;
        opacity: 0;
        transition: all 0.2s;
        &:hover {
          opacity: 1;
        }

        .del-mask {
          position: absolute;
          z-index: 0;
          width: 100%;
          height: 100%;
          left: 0;
          top: 0;
          background: #000;
          opacity: 0.3;
          pointer-events: none;
        }

        .icon-shanchu {
          color: #fff;
          position: relative;
          z-index: 10;
          font-size: 20px;
        }
      }
    }
    .el-upload__tip {
      margin-top: 5px;
    }
  }

  .el-upload-list--picture-card .el-upload-list__item {
    height: 82px;
    width: 82px;
    position: relative;
  }
  .el-upload--picture-card {
    height: 82px;
    width: 82px;
    position: relative;
  }

  .avatar-uploader {
    font-size: 0;
    line-height: 1;
    .el-upload {
      // border: 1px dashed #c0ccda;
      // background-color: rgba(0, 0, 0, 1);
      border-radius: 2px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
      width: 752px;
      height: 264px;
      position: relative;
    }
    .el-upload:hover {
      border-color: #409eff;
    }
    .el-upload-list {
      margin-top: 16px;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 752px;
      height: 264px;
      line-height: 264px;
      text-align: center;
      border: 1px dashed #c0ccda;
      background: rgba(245, 245, 245, 1);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      border: 1px dashed #c0ccda;
      background: rgba(245, 245, 245, 1);
    }
    .el-upload__text {
      font-size: 12px;
      color: rgba(0, 0, 0, 0.65);
      line-height: 22px;
    }
    .avatar {
      width: 752px;
      height: 264px;
      display: block;
    }
    .video-avatar {
      width: 752px;
      height: 264px;
    }
  }

  .videoCover-uploader {
    font-size: 0;
    line-height: 1;
    .el-upload {
      background-color: #fbfdff;
      border-radius: 2px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
      width: 252px;
      height: 152px;
      position: relative;
    }
    .el-upload-list {
      margin-top: 16px;
    }
    .el-upload:hover {
      border-color: #409eff;
    }
    .videoCover-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 252px;
      height: 152px;
      text-align: center;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      border: 1px dashed #c0ccda;
      background: rgba(245, 245, 245, 1);
    }
    .el-upload__text {
      font-size: 12px;
      color: rgba(0, 0, 0, 0.65);
      line-height: 22px;
    }
  }

  .cover {
    width: 252px;
    height: 152px;
    display: block;
  }
  .cover-avatar {
    width: 252px;
    height: 152px;
  }

  .drag-file {
    width: 100%;

    .el-upload {
      width: 100%;
      height: 163px;
      background-color: #f8f9fa;
      border-radius: 8px;
      border: 1px rgba(0, 0, 0, 0.16) dashed;
    }

    .icon-file-drag {
      font-size: 32px;
      color: #00a0d9;
      display: inline-block;
      margin-top: 35px;
    }

    .drag-tips {
      color: #4d4d4d;
      font-size: 14px;
      line-height: 20px;
      font-weight: bold;
      margin-top: 8px;
      width: 100%;
    }

    .file-size-limit {
      color: #818181;
      line-height: 17px;
      font-size: 12px;
      margin-top: 6px;
      width: 100%;
    }

    .el-upload-dragger{
      width: auto;
      height: 160px;
      border:none;
      background: inherit;
    }
  }
}
</style>
